<div class="side-menu-header" (click)="onClick()"
  [ngClass]="{'error' : error, 'valid' : valid, 'warning' : warning, 'select' : selected}">
  <span>
    <span l10nTranslate>{{header}}</span>
    <mat-icon *ngIf="error">error</mat-icon>
    <mat-icon *ngIf="valid">check_circle</mat-icon>
    <mat-icon *ngIf="warning">warning</mat-icon>
  </span>
  <div class="side-menu-header-footnote">
    <ng-content></ng-content>
  </div>
</div>